import { Stack } from 'expo-router';
import DesktopNavigation from 'shared/components/vxl/navigation/DesktopNavigation/DesktopNavigation';
import { useShouldShowDesktopNavigation } from 'shared/hooks/useShouldShowDesktopNavigation';

function DirectDepositSetupLayoutWeb() {
  const shouldShowDesktopNavigation = useShouldShowDesktopNavigation();

  return shouldShowDesktopNavigation ? (
    <DesktopNavigation>
      <Stack />
    </DesktopNavigation>
  ) : (
    <Stack />
  );
}

export default DirectDepositSetupLayoutWeb;
